module.exports = __webpack_public_path__ + "img/logo_white.00c0cd54.svg";